import * as c from '@chakra-ui/react'
import { Link } from 'react-router-dom'
import { ArrowRightIcon } from 'src/assets/icons/nav/arrow-right.icon'

import { HelpItemsConfig } from './data/help-item.config'

interface ItemHelpInterface {
  label: string
  icon: (props: any) => JSX.Element
  path: string
  isExternal: boolean
}

const Item = ({ label, icon, path, isExternal }: ItemHelpInterface) => {
  return (
    <>
      {<c.Divider h="1px" w="full" />}

      {isExternal ? (
        <c.Button
          as={c.Link}
          href={path}
          isExternal
          variant="outline"
          gap="0px"
          px="0px"
          py="s4"
          border="none"
          height="50px"
          fontWeight="medium"
          fontSize="t-lg.1"
          alignItems="center"
          leftIcon={
            <c.Icon as={icon} w="1.25rem" h="1.25rem" color="black.400" />
          }
          _hover={{ bg: 'none' }}
        >
          {label}

          <c.Icon
            ml="auto"
            as={ArrowRightIcon}
            color="black.300"
            w="1.25rem"
            h="1.25rem"
          />
        </c.Button>
      ) : (
        <c.Button
          as={Link}
          to={path}
          variant="outline"
          gap="0px"
          px="0px"
          py="s4"
          border="none"
          height="50px"
          fontWeight="medium"
          fontSize="t-md.0"
          alignItems="center"
          leftIcon={
            <c.Icon as={icon} w="1.25rem" h="1.25rem" color="black.400" />
          }
          _hover={{ bg: 'none' }}
        >
          {label}

          <c.Icon
            ml="auto"
            as={ArrowRightIcon}
            color="black.300"
            w="1.25rem"
            h="1.25rem"
          />
        </c.Button>
      )}
    </>
  )
}

const HelpSection = () => {
  const { notLoggedHelpItems } = HelpItemsConfig()

  return (
    <c.Box mb={['s4', '0px']}>
      {notLoggedHelpItems.map((item) => (
        <Item
          key={item.id}
          path={item.path}
          icon={item.Icon}
          label={item.label}
          isExternal={item.isExternal}
        />
      ))}
    </c.Box>
  )
}

export default HelpSection
